import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ADPResourceService } from 'digital-core';
import { SitefinityContentService } from 'src/app/core/services/settings/sitefinity-content.service';
import { buildDeviceDisplayName } from 'src/app/shared/device/device-display-name.pipe';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';
import { SelectedDeviceService } from 'src/app/shared/device/selected-device.service';

export enum NextStepsInfoDeviceTemplate {
  Smartphone = 'Smartphone',
  Smartwatch = 'Smartwatch',
  Tablet = 'Tablet'
}

@Component({
  selector: 'pgh-next-steps',
  templateUrl: './next-steps.component.html',
  styleUrls: ['./next-steps.component.scss']
})
export class NextStepsComponent implements OnInit {
  @Output() nextEvent = new EventEmitter();
  @Output() backEvent = new EventEmitter();
  @Input() isOnboardingFlow?:boolean = false;
  @Input() deviceName?:string='';
  @Input() nextStepsInfoDeviceTypeTemplate:NextStepsInfoDeviceTemplate;

  public preHeaderTextContext?: { device:string };

  public isSmartphone:boolean=false;
  public isTablet:boolean=false;
  public isSmartwatch:boolean=false;

  public imeiInfoTooltip:string='';
  public preHeaderTextSfKey?: string='RegisterCellularDevice_PreSelectedDevice_DisplayName_Text';

  public preSelectedDevice: PghUserDeviceBase;

  constructor(
    private selectedDeviceService: SelectedDeviceService,
    private resourceService: ADPResourceService
  ) { }

  ngOnInit(): void {

    this.preSelectedDevice = this.selectedDeviceService.getSelectedDevice();

    this.preHeaderTextContext = { device: buildDeviceDisplayName(this.preSelectedDevice)};

    this.imeiInfoTooltip = this.resourceService.getPortalLabel("Onboarding_Diagnostic_NextSteps_IMEI_Tooltip").Value;

    if(this.nextStepsInfoDeviceTypeTemplate === NextStepsInfoDeviceTemplate.Smartphone){
      this.isSmartphone = true;
    }
    else if(this.nextStepsInfoDeviceTypeTemplate === NextStepsInfoDeviceTemplate.Tablet){
      this.isTablet = true;
    }
    else if(this.nextStepsInfoDeviceTypeTemplate === NextStepsInfoDeviceTemplate.Smartwatch){
      this.isSmartwatch = true;
    }

   }

  next() : void {
    this.nextEvent.emit('next');
  }

  back() :void {
    this.backEvent.emit('next');
  }

}
